export enum StyleVariant {
  Default = 'Default',
  Secondary = 'Secondary',
}
